/* RESPONSIBLE TEAM: team-ai-agent-2 */

import IntercomRoute from 'embercom/routes/base/intercom-route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneGuidanceShowRoute extends IntercomRoute {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneGuidanceShowRoute, {
  overrideRenderTemplate: false,
});
